
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hiring-process-comparison",
      function () {
        return require("private-next-pages/hiring-process-comparison.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hiring-process-comparison"])
      });
    }
  